import get from "lodash/get";

import {
  CLEAR_SMART_UI_DETAILS,
  GET_SMART_UI_DETAILS_LOADING,
  GET_SMART_UI_DETAILS_SUCCESS,
  GET_SMART_UI_DETAILS_FAILED,
  GET_SMARTUI_SCREENSHOTS_LOADING,
  GET_SMARTUI_SCREENSHOTS_SUCCESS,
  GET_SMARTUI_SCREENSHOTS_FAILED,
} from "../actionTypeConstants/smartUi";

const initialScreenshotsState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
  offset: 0,
  limit: 10,
};

const initialState = {
  dashboardLink: "",
  buildName: "",
  projectName: "",
  buildId: "",
  projectId: "",
  baseline: false,
  screenshotStatus: {},
  error: null,
  loading: false,
  screenshots: { ...initialScreenshotsState },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SMART_UI_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_SMART_UI_DETAILS_SUCCESS: {
      const smartUiDetails = get(action, ["result", "data"], {});
      const buildInfo = get(smartUiDetails, ["build"], {});
      const projectName = get(smartUiDetails, ["projectName"], "");
      const buildId = get(smartUiDetails, ["build", "buildId"], "") || get(smartUiDetails, ["buildId"], "");
      const projectId = get(smartUiDetails, ["build", "projectId"], "") || get(smartUiDetails, ["projectId"], "");
      const {
        baseline = false,
        name: buildName = "",
        screenshotStatus = {},
      } = buildInfo;
      const smartUiLink = get(
        smartUiDetails,
        ["data", 0, "smartuiDashboardLink"],
        ""
      );
      return {
        ...state,
        loading: false,
        baseline,
        buildName,
        projectName,
        buildId,
        projectId,
        screenshotStatus,
        dashboardLink: smartUiLink,
      };
    }

    case GET_SMART_UI_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        dashboardLink: "",
        baseline: false,
        buildName: "",
        projectName: "",
        buildId: "",
        projectId: "",
        screenshotStatus: {},
      };

    case GET_SMARTUI_SCREENSHOTS_LOADING:
      return {
        ...state,
        screenshots: {
          ...state.screenshots,
          loading: true,
          error: null,
        },
      };

    case GET_SMARTUI_SCREENSHOTS_SUCCESS: {
      const responseData = get(action, ["result", "data"], {});
      const screenshots = get(responseData, ["data", "Screenshots"], []);
      const total = get(responseData, ["total"], 0);
      const buildScreenshotStatus = get(responseData, ["screenshotStatus"], {});
      const limit = get(action, ["meta", "limit"], 10);
      const offset = get(action, ["meta", "offset"], 0);
      return {
        ...state,
        screenshotStatus: buildScreenshotStatus,
        screenshots: {
          data: screenshots,
          total,
          loading: false,
          error: null,
          offset,
          limit,
        },
      };
    }

    case GET_SMARTUI_SCREENSHOTS_FAILED:
      return {
        ...state,
        screenshots: {
          ...state.screenshots,
          loading: false,
          error: get(action, ["error", "message"], "Failed to load screenshots"),
        },
      };

    case CLEAR_SMART_UI_DETAILS:
      return {
        ...state,
        ...initialState,
        screenshots: { ...initialScreenshotsState },
      };

    default:
      return state;
  }
}
